import { render, staticRenderFns } from "./IssuesList.vue?vue&type=template&id=2d7b071a&scoped=true&"
import script from "./IssuesList.vue?vue&type=script&lang=js&"
export * from "./IssuesList.vue?vue&type=script&lang=js&"
import style0 from "./IssuesList.vue?vue&type=style&index=0&id=2d7b071a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b071a",
  null
  
)

export default component.exports